import api from "@/apiConfig/api";
import apiV2 from "@/apiConfig/api-v2";
import { ElMessage } from "element-plus";
import { getDetails } from "@/modules/Teachers/pages/Projects/api/get-projects.api";

export default {
  namespaced: true,
  state() {
    return {
      groups: [],
      pageCount: 1,
      studentId: null,
      group: null,
      nowTime: null,
      nowDate: null,
      groupDays: [],
      archiveDialog: false,
      extendDialog: false,
      courseElements: [],
      courseElementsGroupId: null,
    };
  },
  actions: {
    async getGroups(ctx, { branch_id, status_type, language }) {
      ctx.state.groups = await apiV2
        .get(`/groups`, {
          params: {
            branch_id,
            status_type,
            language,
          },
        })
        .then((res) => res.data)
        .catch((err) => []);
    },
    async getAcademyGroups(
      ctx,
      { branch_id, page, name, has_examination, status_type }
    ) {
      ctx.state.groups = await api
        .get(`/groups`, {
          params: {
            branch_id,
            page,
            name,
            has_examination,
            status_type,
          },
        })
        .then((res) => {
          ctx.state.pageCount = res.data.page_count;
          return res.data.groups;
        })
        .catch((err) => []);
    },
    async getCuratorGroups(ctx, { page, name, status_type }) {
      ctx.state.groups = await apiV2
        .get(`/groups/curator/groups`, {
          params: {
            page,
            name,
            status_type,
          },
        })
        .then((res) => {
          ctx.state.pageCount = res.data.page_count || 1;
          return res.data.groups || res.data || [];
        })
        .catch((err) => []);
    },
    async searchGroups(ctx, { branch_id, name }) {
      ctx.state.groups = await apiV2
        .get(`/groups/search`, {
          params: {
            branch_id,
            name,
          },
        })
        .then((res) => res.data)
        .catch(() => []);
    },
    setStudentId(context, studentId) {
      context.state.studentId = studentId;
    },
    setGroup(context, group) {
      context.state.group = group;
    },
    setNowTime(context, nowTime) {
      context.state.nowTime = nowTime;
    },
    setNowDate(context, nowDate) {
      context.state.nowDate = nowDate;
    },
    setGroupDays(context, groupDays) {
      context.state.groupDays = groupDays;
    },
    setArchiveDialog(context, archiveDialog) {
      context.state.archiveDialog = archiveDialog;
    },
    setExtendDialog(context, val) {
      context.state.extendDialog = val;
    },
    async fetchCourseElements(ctx, groupId) {
      if (!groupId) return [];

      // Return cached if same group
      if (
        String(ctx.state.courseElementsGroupId) === String(groupId) &&
        ctx.state.courseElements.length > 0
      ) {
        return ctx.state.courseElements;
      }

      try {
        const res = await getDetails(groupId);
        const data = Array.isArray(res.data) ? res.data : [];
        ctx.state.courseElements = data;
        ctx.state.courseElementsGroupId = groupId;
        return data;
      } catch {
        ctx.state.courseElements = [];
        ctx.state.courseElementsGroupId = null;
        return [];
      }
    },
    clearCourseElements(ctx) {
      ctx.state.courseElements = [];
      ctx.state.courseElementsGroupId = null;
    },
    async extendGroup(ctx, { group_id, new_date_finished }) {
      const res = await apiV2
        .patch(`/groups/${group_id}/extend`, {
          new_date_finished,
        })
        .then(() => {
          ElMessage.success("Muvaffaqiyatli");
          return true;
        })
        .catch((err) => {
          ElMessage.error(err?.response?.data?.detail?.error || "Xatolik");
          return false;
        });
      return res;
    },
    async getGroupById(ctx, { groupId, all }) {
      ctx.state.group = null;
      await api
        .get(`/groups/${groupId}`, {
          params: {
            group_id: groupId,
            all: all,
          },
        })
        .then((res) => {
          ctx.state.group = res.data;
        })
        .catch(() => null);
    },
    async changeGroupStatus(ctx, { group_id, status }) {
      const res = await apiV2
        .patch(
          `/groups/${group_id}/change-status`,
          {
            status,
          },
          {
            params: {
              group_id,
            },
          }
        )
        .then(() => {
          ElMessage.success("Muvaffaqiyatli");
          return true;
        })
        .catch((err) => {
          ElMessage.error(err);
          return false;
        });

      return res;
    },
    async changeGroupOwnStatus(ctx, { group_id, own_status }) {
      const res = await apiV2
        .patch(
          `/groups/${group_id}/change-status`,
          {
            own_status,
          }
        )
        .then(() => {
          ElMessage.success("Muvaffaqiyatli");
          return true;
        })
        .catch((err) => {
          ElMessage.error(err);
          return false;
        });

      return res;
    },
  },
};
